







































import {defineComponent, onMounted, computed, PropType} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import StudySearch from "@/apps/MyStudyChoiceFavoritesWidget/components/Studies/StudySearch.vue"
import AddStudyButton from "./Favorites/AddStudyButton.vue"
import FavoriteStudy from "./Favorites/FavoriteStudy.vue"
import CardAtom from "@/shared/components/atoms/card/CardAtom.vue"
import ListAtom from "@/shared/components/atoms/card/ListAtom.vue"
import Loader from "@/shared/components/Loader.vue"
import {Config} from "@/apps/MyStudyChoiceFavoritesWidget/models/config-viewmodel"

export default defineComponent({
    name: "MyStudyChoiceFavorites",
    components: {
        AddStudyButton,
        FavoriteStudy,
        StudySearch,
        ListAtom,
        CardAtom,
        Loader,
    },
    props: {
        config: {
            type: Object as PropType<Config>,
            required: true
        }
    },
    setup: (props) => {
        const { loadMyStudyChoiceStudies, setStudySearchModal, setConfig} = useActions([
            'loadMyStudyChoiceStudies',
            'setStudySearchModal',
            'setConfig'
        ]);
        setConfig(props.config)
        const {getStudySearchModal, getFavoriteStudies, loading} = useGetters([
            'getStudySearchModal',
            'getFavoriteStudies',
            'loading'
        ]);
        const loadText = props.config?.language === 'nl' ? 'Even geduld... Uw studie keuzes worden geladen' : 'One moment please... Your study choices are loaded';

        onMounted(async () => {
            await loadMyStudyChoiceStudies();
        })

        const studySearchModal = computed({
            get() {
                return getStudySearchModal.value
            },
            set(studySearchModal) {
                setStudySearchModal(studySearchModal)
            },
        });

        return {
            loading,
            loadText,
            studySearchModal,
            getFavoriteStudies
        }
    }
})
